import { useEffect } from 'react';
import { useDeliveryHours } from '@mafc/common';
import { isNonEmptyArray } from 'utils/helpers.util';
import CONSTANTS from 'config/constants';

import { ICartState } from 'pages/NewCart/redux/reducers';
import useCart from 'pages/NewCart/hooks/useCart';
import { INewCartShipment } from '../ICart';
import { useDispatch } from 'react-redux';
import { fetchSubstitutes } from '../redux/actions/substitutes.action';
import useOOSSubstitute from 'hooks/useOOSSubstitute';

const useCartShipments = (
  shouldFetch = true
): {
  shipments: INewCartShipment[];
  isLoading: boolean;
  isCartEmpty: boolean;
  refreshSubstitutes: () => void;
} => {
  const dispatch = useDispatch();
  const cartState: ICartState = useCart(shouldFetch);
  const isOOSSubstitutionEnabled = useOOSSubstitute();
  const { isNowUnavailableHour } = useDeliveryHours();

  const {
    cartData: { shipments = [] },
    errorMessage = '',
    loading: isLoading,
  } = cartState;

  const isCartNotAvailable = errorMessage === CONSTANTS.guidUnavailable;
  const isEmptyShipment = !isNonEmptyArray(shipments as INewCartShipment[]);
  const isCartEmpty = !isLoading && (isEmptyShipment || isCartNotAvailable);
  const refreshSubstitutes = () => {
    dispatch(fetchSubstitutes(isNowUnavailableHour));
  };

  useEffect(() => {
    if (shouldFetch && !isEmptyShipment && isOOSSubstitutionEnabled) {
      refreshSubstitutes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmptyShipment, isOOSSubstitutionEnabled]);

  return {
    shipments,
    isLoading,
    isCartEmpty,
    refreshSubstitutes,
  };
};

export default useCartShipments;
